import en from "./en";
import nl from "./nl";
import de from "./de";
import fr from "./fr";

export const translations = { en, nl, de, fr };

export const SUPPORTED_LANGUAGES = ["en", "de", "nl", "fr"];

// Native display names, used by the LanguageSwitcher dropdown.
export const LANGUAGE_LABELS = {
  en: "English",
  de: "Deutsch",
  nl: "Nederlands",
  fr: "Français",
};

export default translations;
